// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__BKUj5","list":"BalanceDue_list__nzC-I","listRow":"BalanceDue_listRow__2tqJx","total":"BalanceDue_total__2ora2"};